<template>
  <div class="bim-steps-icon" :class="type">

    <!-- Успех -->
    <div
      v-if="type === STEPS_ENUM.SUCCESS"
      v-html="require('@/assets/img/icon-saved-small-neon.svg')"
    ></div>

    <!-- Предупреждение -->
    <div
      v-if="type === STEPS_ENUM.ERROR"
      v-html="require('@/assets/img/warning.svg')"
    ></div>

  </div>
</template>

<script>
import STEPS_ENUM from './steps.enum'
export default {
  name: 'bimStepsIcon',
  props: {
    /**
     * string<STEPS_ENUM>
     */
    type: String
  },
  data () {
    return {
      STEPS_ENUM
    }
  }
}
</script>

<style lang="scss" scoped>
.bim-steps-icon {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;
  border-radius: 50%;

  box-sizing: border-box;
  z-index: 1;

  // Текущий
  &.current {
    border: solid 6px #eeeeee;
    background-color: #00afa1;
  }

  // Ошибка
  &.error {
    background-color: #eeeeee;

    div {
      width: 6px;
      height: 14px;
      display: flex;
    }
  }

  // Успех
  &.success {
    background-color: #e0f4f2;

    div {
      width: 14px;
      height: 11px;
      display: flex;
    }
  }

  // Пустой
  &.empty {
    background-color: white;
    border: 6px solid #eeeeee;
  }
}
</style>
